<div class="title"></div>

<div class="message">
    <p [innerHTML]="message"></p>
</div>
